module.exports = __webpack_public_path__ + "static/img/victory.ac8b1ac.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/victory.gif
// module id = zUMh
// module chunks = 1